export * from "./validateEmail";

//TODO: Rethink this implementation of webP detection
let webPsupported;
const canUseWebP = () => {
  if (typeof webPsupported !== "undefined") {
    return webPsupported;
  }

  if (typeof document !== "object") {
    webPsupported = false;
    return false;
  }

  // Use the canvas method for basic check
  const canvas = document.createElement("canvas");
  if (canvas.toDataURL("image/webp")?.indexOf("data:image/webp") === 0) {
    webPsupported = true;
    return true;
  }

  // Use Image object for a more thorough check
  webPsupported = false;
  const image = new Image();
  image.onload = () => {
    webPsupported = image.width === 2 && image.height === 2;
  };
  image.onerror = () => {
    webPsupported = false;
  };
  image.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";

  return webPsupported;
};

canUseWebP();
